/**
 * File track-module-viewed.js.
 * Handles firing Segment events when modules are viewed
 */

const modules = document.querySelectorAll('.module');
const moduleLocation = window.location.href;
let moduleObserverOptions = {
  threshold: [0.75]
};

let handleModuleView = (entries, observer) => {
  entries.forEach(entry => {
    const module = entry.target;

    if (module.offsetHeight == 0) {
      return;
    }

    const moduleType = module?.dataset?.name ?? (module.closest('.sub-navigation') ? 'sub-navigation' : '');
    const moduleName = module.getAttribute('data-name')?.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    const moduleIndex = module.getAttribute('data-index') || 'n/a';
    let moduleHeader = module.querySelector('h1') || module.querySelector('h2') || "n/a";
    const hasEnrollLink = module.querySelector('a.enroll-link');
    const hasEmailCapture = module.querySelector('.email-capture__submit');
    const hasAnyLink = module.querySelector('a');
    const ctaLinks = document.querySelectorAll('.double-cta-links .cta-link');

   const ctaType = ctaLinks.length > 0
    ? 'Double CTA'
    : hasEnrollLink || hasEmailCapture
      ? 'enrollment'
      : hasAnyLink
        ? 'engagement'
        : 'No CTA';
    
    const moduleData = {
      module_type: moduleType,
      module_index: moduleIndex,
      module_title: moduleName,
    }
    
    moduleHeader = 
    (moduleHeader && typeof moduleHeader === 'object' && 'textContent' in moduleHeader)
      ? moduleHeader.textContent.replace(/\n/g, '').replace(/\s+/g, ' ').trim()
      : 'n/a';

    let properties = {
      module_location: moduleLocation,
      module_name: moduleName,
      module_index: moduleIndex,
      module_header: moduleHeader
    }

    if (entry.isIntersecting) {
      // Analytics SDK double fire
      window.waitForAnalyticsSDK().then(() => {
        fireAnalyticsEvent(Track.WebItemViewed, {
          unique_id: 'module_viewed',
          element_type: "ELEMENT_TYPE_SECTION",
          label: moduleName,
          item_value: ctaType,
          item_details: {
            "module_viewed": {
              "module": {
                ...moduleData,
              },
            }
          }
        });
      })

      segment(
        'track',
        'Module Viewed',
        properties
      );

      moduleObserver.unobserve(module);
    }
  })
}

const moduleObserver = new IntersectionObserver(handleModuleView, moduleObserverOptions);

modules.forEach(module => {
  moduleObserver.observe(module);
});
